module.exports = __webpack_public_path__ + "static/img/copy.2dc2b551.svg";